import { Card } from '@/components/ui/card'
import AuthLayout from '../auth-layout'
import { UserAuthForm } from './components/user-auth-form'


export default function SignIn() {
  return (
    <AuthLayout>
      <Card className='p-8 max-w-md mx-auto shadow-lg rounded-xl'>
        <div className='mb-6 text-center'>
          <h1 className='text-2xl font-bold tracking-tight'>Giriş Yap</h1>
          <p className='text-sm text-muted-foreground mt-2'>Hesabınıza erişmek için e-posta ve şifrenizi girin.</p>
        </div>
        <UserAuthForm />

      </Card>
    </AuthLayout>
  )
}
